export default __webpack_public_path__ + "static/media/pic-2.08092241.jpg";